import { render, staticRenderFns } from "./SubjectView.vue?vue&type=template&id=7b31ccdf&"
import script from "./SubjectView.vue?vue&type=script&lang=js&"
export * from "./SubjectView.vue?vue&type=script&lang=js&"
import style0 from "./SubjectView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports